import React from "react";
import * as Styled from "./PromoCarousel.styled";
import { ButtonOrange } from "../../elements/Buttons";
import SendUTMQueryParams from "../../elements/SendUTMQueryParams/SendUTMQueryParams";

function SlideTextImage({slideItem}) {
  return (
    <Styled.ContentWrapper>
      <Styled.PromoContent>
        <Styled.TitleBadgeWrapper>
          <Styled.TitleBadge>{slideItem.titleBadge}</Styled.TitleBadge>
        </Styled.TitleBadgeWrapper>
        <Styled.PromoContentTitle color={'#ffffff'}>
          {slideItem.vehicleTitle}
        </Styled.PromoContentTitle>
        <Styled.PromoContentSubTitle>
          {slideItem.vehicleSubTitle}
        </Styled.PromoContentSubTitle>
        {slideItem.priceDollar !== "" && (
          <Styled.PromoContentPrice>
            <span className="from">from</span>
            <sup className="small">$</sup>
            {slideItem.priceDollar}
            <span className="period">{slideItem.period}</span>
          </Styled.PromoContentPrice>
        )}
        <ButtonOrange labelCTA="Get a quote" onClick={SendUTMQueryParams} />
          <Styled.PromoContentDisclaimerText>
            {slideItem.disclaimerText}
            {slideItem.termsLinkUrl && (
              <Styled.PromoContentTermsLink
                href={slideItem.termsLinkUrl}
                target="_blank"
              >
                *T&Cs Apply
              </Styled.PromoContentTermsLink>
            )}
          </Styled.PromoContentDisclaimerText>
      </Styled.PromoContent>
      <picture>
        <source
          media="(max-width: 799px)"
          srcSet={`${slideItem.imageMobile}`}
        />
        <source media="(min-width: 800px)" srcSet={`${slideItem.image}`} />
        <Styled.VehicleImg src={slideItem.image} alt={slideItem.vehicleTitle} />
      </picture>
    </Styled.ContentWrapper>
  );
}

export default SlideTextImage;
